module.exports = __webpack_public_path__ + "media/profile/score-trophy-52c48d36.png";